import { useLocation } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

import { Card } from '../ui/card';
import { Breadcrumbs } from './breadcrumbs';
import { DashboardNav } from './dashboard-nav';
import { TopRightFunction } from './top-right-function';

export type DashboardLayoutProps = React.ComponentProps<'div'> & {
  topContent?: React.ReactNode;
  type: 'estate' | 'project';
};

export const DashboardLayout = ({
  className,
  children,
  topContent,
  type,
  ...props
}: DashboardLayoutProps) => {
  // Hide the Dashboard Nav for specific routes
  const location = useLocation();
  const currentRoute = location.pathname;
  const hideNavPatterns = [/^\/(estates|projects)\/[^/]+\/media\/edit\/[^/]+$/];
  const hideNav = hideNavPatterns.some((regex) => regex.test(currentRoute));

  return (
    <div className={cn('flex flex-1 flex-col gap-4', className)} {...props}>
      <div className="flex flex-col gap-4">
        {topContent}
        <div className="flex items-center gap-4">
          <Breadcrumbs />
          <TopRightFunction />
        </div>
        {!hideNav && (
          <Card className="rounded-md p-[5px]">
            <DashboardNav type={type} />
          </Card>
        )}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
